export const CONTACT = {
  phone: "667-434-4392",
  phoneRaw: "+16674344392",
  email: "integritydelivered1@gmail.com",
  location: "Sparrows Point, MD",
  hours: "Daily 8:00 AM – 8:00 PM",
  handle: "integritydeliveredmd",
  facebook: "https://www.facebook.com/integritydeliveredmd",
  instagram: "https://www.instagram.com/integritydeliveredmd",
  linkedin: "https://www.linkedin.com/company/integritydeliveredmd",
};
